import CommerceCheckoutLabel from './CommerceCheckoutLabel';
import {px, percent} from '@packages/systems/core/utils/WebflowCssSubset';
import {Atom} from '@packages/systems/wfdl';

const config = Atom.create({
  ...Atom.getConfigShape(CommerceCheckoutLabel),
  style: {
    base: {
      main: {
        noPseudo: {
          marginBottom: px(8),
          flexBasis: percent(100),
        },
      },
    },
  },
});

export default config;
